import { IWellnessPlanDetails } from "../../services/wellness-plan/wellness-plan.interface";
import { actionTypes } from "./wellness-plan.actions";

export interface IWellnessPlanState {
  wellnessPlanDetails: IWellnessPlanDetails | null;
}

const initialState: IWellnessPlanState = {
  wellnessPlanDetails: null,
};

export const wellnessPlanReducer = (
  state: IWellnessPlanState = initialState,
  action: { type: string, payload: any },
): IWellnessPlanState => {
  switch (action.type) {
  case actionTypes.SET_WELLNESS_PLAN_DETAILS:
    return {
      ...state,
      wellnessPlanDetails: action.payload,
    };
  default:
    return state;
  }
};
